export default {
  deactivate: {
    ar: "الغاء التفعيل",
    en: "Deactivate"
  },
  activate: {
    ar: "تفعيل",
    en: "Activate"
  }
}